export class Segment {
  constructor(href, storage, quizList, queryStorage) {
    try {
      const url = new URL(href);
      this.url = url;
      this.storage = storage;
      this.quizList = quizList;
      this.queryStorage = queryStorage;

      this.setupFields();
      this.saveSegmentInStorage();
    } catch (error) {
      throw error;
    }
  }

  setupFields() {
    this.segmentQueryString = this.url.searchParams.get("segment");
    this.segmentQuizConfig = this.getSegmentQuizConfig();
    this.segmentStorage = this.storage.get("client_segment");
  }

  saveSegmentInStorage() {
    const segment = this.getId();
    if (this.storage) {
      this.storage.set("client_segment", segment);
    }
  }

  saveSegmentQueryString() {
    const segment = this.getId();
    if (this.queryStorage) {
      this.queryStorage.set("segment", segment);
    }
  }

  getSegmentQuizConfig() {
    const { pathname } = this.url;
    const pathParts = pathname.split("/");
    const quizName = pathParts.includes("v2") ? pathParts[4] : pathParts[3];
    const quizObject = this.quizList[quizName];

    return quizObject?.parameters?.segment;
  }

  getId() {
    return this.segmentQueryString || this.segmentQuizConfig || this.segmentStorage;
  }

  setId(id) {
    this.segmentQueryString = id;
    this.segmentStorage = id;
    this.saveSegmentQueryString();
    this.saveSegmentInStorage();
  }
}
